const _directiveDependencies = [];
const _controllerDependencies = ['$rootScope'];

class DisclaimerBarController {

    constructor($rootScope) {

        this.$rootScope = $rootScope;

        // Check vpn disclaimer
        this.isDisclaimerVisible = this.$rootScope.vpnINdisclaimer;

    }

    closeDisclaimer() {

        this.isDisclaimerVisible = false;

        localStorage.setItem('disclaimerBar', 'closed');

        angular.element('body').removeClass('show-disclaimer-bar');

    }

}


class DisclaimerBarDirective {

    constructor() {

        this.template = require('./disclaimer-bar.html');
        this.restrict = 'E';
        this.replace = true;


        _controllerDependencies.push($rootScope =>
            new DisclaimerBarController($rootScope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'disclaimerBarCtrl';

    }

}

_directiveDependencies.push(() => new DisclaimerBarDirective());

angular.module('directives')
    .directive('disclaimerBar', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/disclaimer-bar/disclaimer-bar.js